//-
const scrollToTop = $('.scrollToTop');
const btnScrollTo = $('#btnScrollTo');

scrollToTop.on('click', function (event) {
    $('html, body').animate({
        scrollTop: $("body").offset().top
    }, 1000);
});

$(window).on('scroll', function () {
    var wH = $(window).height(),
        wS = $(this).scrollTop();

    if (wS >= wH) {
        btnScrollTo.addClass('show');
    } else {
        btnScrollTo.removeClass('show');
    }
});

//-
window.smoothScrollToValue = function smoothScrollToValue(top, left) {
    window.scrollTo({
        top: top, //- number
        left: left,//- number
        behavior: 'smooth'
    });
}

//-
function appHeight() {
    document.documentElement.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
};

// window.addEventListener('resize', function(){
//     setTimeout(function() {
//         appHeight();
//     }, 250);
// });

appHeight(); 

//-
window.doWhenInViewport = function doWhenInViewport(el, callback, threshold = 0) {
    const options = {
        root: null,
        threshold: threshold
    };

    let observer = new IntersectionObserver(callback, options);
    observer.observe(el);
}

// Infographic bars animation
const bars = document.querySelectorAll('.infographic__bar[data-amount]');

function animateProgressBar() {
    bars.forEach(bar => {   
        const scrollPosition = window.scrollY + window.innerHeight;
        const barPosition = bar.offsetTop + bar.offsetHeight;
        
        const amount = bar.getAttribute('data-amount').replace(/[^\d]/g, '');
        const maxSize = 100; 
        const filledSize = (amount / 15) * maxSize; 

        if (scrollPosition >= barPosition) {
            if (document.querySelector(".infographic__info-section").classList.contains("infographic__info-section--vertical")) bar.style.height = `${filledSize}%`
            else bar.style.width = `${filledSize}%`
            bar.classList.add('infographic__bar--fill');
        }
    });
}
    
window.addEventListener('scroll', animateProgressBar);